import React,{useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom'; 
import Header from '../header/Header';
import { MobileMenu } from '../mobileMenu/MobileMenu';
import Menu from '../menu/Menu';
import CustomerChoice from '../customerChoice/CustomerChoice';
import { CustomerChoiceCompany } from '../customerChoice/CustomerChoiceCompany';
import red_line from '../../img/red_line.png';
import '../pageSize/PageSize.css'; 
import './CustomerTypePage.css';
import { SectionTitle } from '../common/sectionTitle/SectionTitle';
import { MENU_ITEMS } from '../common/newMenu/menuItems/MenuItems'; 
import NewMobileMenu from '../common/newMenu/NewMobileMenu';
import NewDesktopMenu from '../common/newMenu/NewDesktopMenu';

export const CustomerTypePage = () => {
  const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 600px)").matches);   
  const [isChoiceSelected, setIsChoiceSelected] = useState(false);
  const [isChoiceCompanySelected, setIsChoiceCompanySelected] = useState(false);

  const handleChoiceSelected = (fromComponent) => {
    if (fromComponent === "CustomerChoice") {
      setIsChoiceSelected(true);
      setIsChoiceCompanySelected(false);
    } else if (fromComponent === "CustomerChoiceCompany") {
      setIsChoiceCompanySelected(true);
      setIsChoiceSelected(false);
    }
  };

  useEffect(() => {
    const handleWindowResize = () => {
      setIsMobile(window.matchMedia("(max-width: 767px)").matches);
    };
    window.addEventListener("resize", handleWindowResize);  
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return (
    <div className="page-size">
      {/* HEADER */}
      <Header />

      {/* MENU */}
      {isMobile 
        ? <NewMobileMenu items={MENU_ITEMS} /> 
        : <NewDesktopMenu items={MENU_ITEMS} />
      }

      {/* MAIN CONTENT */}
      <div className="main-content" style={{ marginTop: '200px' }}>
        <SectionTitle text="Typ klienta" />
        <p className="client-type-subtitle">
          Wybierz typ klienta i rodzaj zgłoszenia
        </p>

        <div className="client-type-options">
          <div className="card-wrapper">
            <CustomerChoiceCompany
              onChoiceCompanySelected={() => handleChoiceSelected("CustomerChoiceCompany")}
              isChoiceCompanySelected={isChoiceCompanySelected}
              isChoiceSelected={isChoiceSelected}
            />
          </div>
          <div className="card-wrapper">
            <CustomerChoice
              onChoiceSelected={() => handleChoiceSelected("CustomerChoice")}
              isChoiceSelected={isChoiceSelected}
              isChoiceCompanySelected={isChoiceCompanySelected}
            />
          </div>
        </div>
      </div>
    </div>
  );
};